import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Crown, BadgeCheck, Loader2 } from "lucide-react";
import { fetchHotelProStatus, startHotelProSubscription, verifyProSubscription } from "@/lib/api";
import { fmtPrice } from "@/lib/utils";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "");

export const HotelProCard = ({ hotel, onChanged }) => {
  const [params, setParams] = useSearchParams();
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const load = () => hotel?.id && fetchHotelProStatus(hotel.id).then(setStatus).catch(() => {});

  useEffect(() => {
    const tx = params.get("tx");
    if (params.get("paiement") && tx) {
      setBusy(true);
      verifyProSubscription(tx)
        .then((r) => { setMsg(r.activated ? "Paiement confirme — Pro Hotel actif !" : r.payment_status === "failed" ? "Paiement non finalise." : "Paiement en cours de verification…"); if (r.activated) onChanged?.(); })
        .catch(() => setMsg("Verification impossible pour le moment"))
        .finally(() => { setBusy(false); load(); params.delete("paiement"); params.delete("tx"); params.delete("status"); params.delete("dryrun"); setParams(params, { replace: true }); });
    } else {
      load();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hotel?.id]);

  const subscribe = async () => {
    setBusy(true); setMsg("");
    try {
      const r = await startHotelProSubscription(hotel.id);
      if (r.paiement_requis === false) { setMsg(r.message); setBusy(false); return; }
      window.location.href = r.payment_url;
    } catch (e) { setMsg(e?.response?.data?.detail || "Erreur de paiement"); setBusy(false); }
  };

  if (!status) return null;
  const pro = status.mode === "pro";
  const lancement = status.mode === "lancement";
  const label = pro ? `Pro Hotel actif jusqu'au ${fmtDate(status.until)}`
    : lancement ? `Offre de lancement (place n°${status.place_no}) — gratuit jusqu'au ${fmtDate(status.until)}`
    : status.mode === "trial" ? `Essai gratuit Tarif Express jusqu'au ${fmtDate(status.until)}`
    : status.mode === "trial_not_started" ? `Essai gratuit de ${status.trial_days} jours au premier envoi Tarif Express`
    : "Essai termine — abonnement requis pour Tarif Express";

  return (
    <div className={`glass-card p-5 ${pro ? "border-2 border-amber-300" : ""}`} data-testid="hotel-pro-card">
      <div className="flex items-center gap-2 text-sm font-bold mb-1"><Crown size={16} className="text-amber-500" /> Pro Hotel — {fmtPrice(status.amount)} / mois</div>
      <p className="text-xs text-[var(--ink-soft)]">Tarif Express illimite + badge <b>Hotel partenaire</b> + mise en avant en tete de la page Hotelleries.</p>
      <div className={`mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-semibold ${pro ? "bg-amber-50 text-amber-800" : status.active ? "bg-emerald-50 text-emerald-800" : "bg-red-50 text-red-700"}`} data-testid="hotel-pro-status">
        {pro && <BadgeCheck size={14} />} {label}
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        {lancement ? (
          <div className="text-sm text-emerald-800 font-semibold" data-testid="hotel-pro-lancement">Aucun paiement requis pendant l'offre. Rappel SMS 3 jours avant la fin, puis bascule vers {fmtPrice(status.amount)} / mois.</div>
        ) : (
        <button onClick={subscribe} disabled={busy} className="btn-primary inline-flex items-center gap-2" data-testid="hotel-pro-subscribe">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Crown size={14} />} {pro ? "Prolonger 30 jours" : "Souscrire Pro Hotel"} — {fmtPrice(status.amount)}
        </button>
        )}
        {status.pending_payment && (
          <button type="button" onClick={subscribe} disabled={busy} className="text-sm font-semibold text-orange-600 underline" data-testid="hotel-pro-resume">Reprendre le paiement en attente (nouveau lien sécurisé)</button>
        )}
      </div>
      {msg && <div className="mt-3 text-sm font-semibold" data-testid="hotel-pro-msg">{msg}</div>}
    </div>
  );
};
